import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    addActivityContainer: {
        maxWidth: 900,
        marginTop: 85,
        userSelect: "none",
        [theme.breakpoints.down("sm")]: {
            padding: 10,
            margin:0
        },
    },
    roleAndTitleContainer: {
        flexWrap: "nowrap",
        marginBottom: 62,
        paddingRight:"16px",
        [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            flexDirection: "column !important",
            marginBottom: 12,
        },
    },
    roleContainer: {
        maxWidth: 350,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
            width: "100%",
            marginTop: 30,
        },
    },
    star: {
        color: "#d50a0a",
        fontSize: 18,
        fontWeight: "bold",
        paddingRight: "10px",
        paddingLeft: "4px",
        position: "relative",
        top: 3,
    },
    star2: {
        color: "#d50a0a",
        fontSize: 18,
        fontWeight: "bold",
        padding: "0 5px",
        position: "relative",
        top: 3,
    },
    fieldTitleContainer: {
        display: "flex",
        flexWrap: "nowrap",
        [theme.breakpoints.down("sm")]: {
            width: 105,
        },
    },
    grid: {
        flexDirection: "column",
        padding: "0 15px",
        marginBottom: 25,
        [theme.breakpoints.down("sm")]: {
            flexDirection: "row",
            padding: 0,
            marginBottom: 12,
            alignItems: "center",
        },
    },
    dateDialog: {
        "& .MuiDialog-paper": {
            "& .MuiPickersToolbar-toolbar": {
                backgroundImage: "linear-gradient(to right ,#0ebca0,#1978ba)",
                "& .MuiButton-label h6": {
                    fontSize: 22,
                },
            },
        },
    },
    textarea: {
        width: "100%",
        height: 200,
        userSelect: "none",
        fontSize: 15,
        borderRadius: 5,
        boxShadow: "0 3px 31px 0 rgba(0, 0, 0, 0.15)",
        padding: "3px 15px",
        border: "none",
        fontFamily: "iranSans",
        backgroundColor: "#fff",
        resize: "none",
        "&:focus": {
            outline: "none",
        },
        marginTop: 10,
    },
    yellowBtn: {
        color: "#000",
        fontWeight: "700",
        marginTop: 30,
        backgroundColor: "#ffd200",
        fontSize: 18,
        boxShadow: "0 3px 42px 0 #d0ad0b",
        "&:hover": {
            backgroundColor: "#ffd200",
        },
    },
    addActivityButton: {
        backgroundColor: "#0ca160",
        color: "#fff",
        minWidth: 80,
        minHeight: 38,
        fontWeight: "bold",
        boxShadow: "0 3px 42px 0 rgba(12, 161, 96, 0.47)",
        borderRadius: 20,
        "&:hover": {
            backgroundColor: "#1f704c",
        },
    },
    addActivityButtonDisabled: {
        width: 80,
        height: 38,
        borderRadius: 20,
    },
    padding30: {
        padding: 30,
    },
    selectFile: {
        borderRadius: 20,
        padding: "8px 15px",
        backgroundColor: "#f64366",
        color: "#fff",
        fontSize: 18,
        display: "flex",
        justifyContent: "center",
        cursor: "pointer",
    },
    fileInput: {
        position: "absolute",
        top: 13,
        height: 50,
        width: 120,
        visibility: "hidden",
        cursor: "pointer",
    },
    saveImageContainer: {
        padding: "0 30px",
    },
    saveImageInsideContainer: {
        backgroundColor: "#fff",
        boxShadow: " 0 6px 12px 0 rgba(0, 0, 0, 0.05)",
        height: 60,
        padding: "0 25px",
        marginTop: 6,
    },
    saveImage: {
        backgroundColor: "#ebebeb",
        borderRadius: 30,
        height: 40,
        boxShadow: "none",
    },
    divider: {
        height: 1,
        backgroundColor: "#a6a6a6",
        margin: "35px 0px",
    },
    imageSectionContainer: {
        padding: "0 30px",
        minHeight: 122,
    },
    documentContainer: {
        paddingBottom: 10,
        borderBottom: "1px dashed #d0d0d0",
        marginTop:10
    },
    primaryBtn: {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        padding: "5px 15px",
        borderRadius: 5,
    },
    cancelBtn: {
        backgroundColor: "rgb(25 120 186 / 10%)",
        padding: "5px 20px",
        borderRadius: "5px",
    },
    documentBoxContainer: {
        minHeight: 150,
    },
    documentItemContainer: {
        padding: "10px 20px",
        backgroundColor: "#ffff",
        borderRadius: 8,
        marginTop: 10,
    },
    documentTitle: {
        width: 260,
        maxWidth: 260,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    removeContainer: {
        width: 260,
    },
    removeDocIcon: {
        color: "#f64366",
    },
}));
export default useStyles;
